var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { BlueLink } from '@hn-ui/links';
import { Tooltip } from '@hn-ui/tooltips';
import { useWeeklyDashboardAnalytics, WeeklyDashboardEvents, } from '../../../../hooks/useWeeklyDashboardAnalytics';
import { formatDistance, parseISO } from 'date-fns';
import { cutText } from '../../../../utils/text';
var NAME_MAX_LENGTH = 10;
var Name = styled(BlueLink).withConfig({ displayName: "Name", componentId: "sc-1sajva1" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: bold;\n"], ["\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: bold;\n"])));
var LastVisit = styled.p.withConfig({ displayName: "LastVisit", componentId: "sc-1ej44jm" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #777b8b;\n\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: -0.2px;\n\n  ", "\n"], ["\n  color: #777b8b;\n\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: -0.2px;\n\n  ", "\n"])), function (_a) {
    var $isOnline = _a.$isOnline;
    return $isOnline && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: #479a19;\n    "], ["\n      color: #479a19;\n    "])));
});
var NameCell = function (_a) {
    var student = _a.student, isCurrentWeek = _a.isCurrentWeek;
    var lastVisit = student.lastVisit;
    var sendGaEvent = useWeeklyDashboardAnalytics();
    return (_jsxs("div", { children: [_jsx(Tooltip, __assign({ content: student.fullName, maxWidth: 'none', mouseOnly: true, interactive: student.fullName.length > NAME_MAX_LENGTH }, { children: _jsx(Name, __assign({ href: student.link, onClick: function () {
                        return sendGaEvent(student.struggle
                            ? WeeklyDashboardEvents.struggleStudentLinkClick
                            : WeeklyDashboardEvents.studentLinkClick);
                    }, onMouseEnter: function () {
                        sendGaEvent(WeeklyDashboardEvents.studentNameHover);
                    }, target: '_blank' }, { children: cutText(student.fullName, NAME_MAX_LENGTH) }), void 0) }), void 0), isCurrentWeek &&
                (lastVisit ? (_jsx(OnlineStatus, { lastVisit: lastVisit }, void 0)) : (_jsx(LastVisit, { children: "-" }, void 0)))] }, void 0));
};
var OnlineStatus = function (_a) {
    var lastVisit = _a.lastVisit;
    var currentDate = new Date();
    var visitDate = parseISO(lastVisit);
    var timeDiff = currentDate.getTime() - visitDate.getTime();
    var isOnline = timeDiff <= 300000;
    var status = isOnline
        ? 'online now'
        : formatDistance(visitDate, currentDate, { addSuffix: true });
    return _jsx(LastVisit, __assign({ "$isOnline": isOnline }, { children: status }), void 0);
};
export { NameCell };
var templateObject_1, templateObject_2, templateObject_3;
